import { createContext, useContext, useEffect, useState } from 'react';

const API = process.env.REACT_APP_API_BASE_URL || `${process.env.FRONTEND_URL}/api`;
const CountryContext = createContext({ countries: [], loading: true, refreshCountries: () => {} });

export function slugifyCountry(country) { return country.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, ''); }

export function CountryProvider({ children }) {
  const [countries, setCountries] = useState([]); const [loading, setLoading] = useState(true);
  const refreshCountries = () => fetch(`${API}/country-guides`).then(r => r.json()).then(json => setCountries(json.success ? json.data : [])).catch(() => setCountries([])).finally(() => setLoading(false));
  useEffect(() => { refreshCountries(); }, []);
  return <CountryContext.Provider value={{ countries, loading, refreshCountries }}>{children}</CountryContext.Provider>;
}
export const useCountries = () => useContext(CountryContext);
